import { createFileRoute } from '@tanstack/react-router'

import { SettlementDetailPage } from '@/pages/admin/settlements/settlement-detail-page'

export const Route = createFileRoute('/_private/admin/settlements_/$settlementId')({
  component: SettlementDetailPage,
})
